import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import type { Prismic } from '@landsbankinn/prismic';
import { isEmptyText, PrismicText } from '@landsbankinn/prismic';
import { Segment, Reveal } from '@landsbankinn/ui';
import React from 'react';
import { Bonds } from '../components/markets/bonds/Bonds';
import type { CategoryOrder } from '../components/markets/funds/Funds';
import { Funds } from '../components/markets/funds/Funds';
import fundRes from '../components/markets/funds/Funds.res';
import res from '../components/markets/shared/markets-disclaimer/MarketsDisclaimer.res';
import { Stocks } from '../components/markets/stocks/Stocks';

interface IProps {
  instrument: string;
  order: CategoryOrder;
  disclaimer?: Prismic.RichText;
}

const Disclaimer = styled.div`
  margin-top: -30px;
`;

export const MarketsContainer = ({ instrument, order, disclaimer }: IProps) => {
  const isEmpty = isEmptyText(disclaimer);
  const { r } = useResource();
  return (
    <Segment paddingTop={80}>
      {instrument === 'Bonds' && (
        <Reveal>
          <Bonds
            prefix="/markadir/skuldabref"
            disclaimerText={r(res.disclaimer['landsbankinn'])}
          />
        </Reveal>
      )}
      {instrument === 'Stocks' && (
        <Reveal>
          <Stocks
            prefix="/markadir/hlutabref"
            disclaimerText={r(res.disclaimer['landsbankinn'])}
          />
        </Reveal>
      )}
      {instrument === 'Funds' && (
        <Reveal>
          <Funds
            order={order}
            prefix="/markadir/sjodir/"
            disclaimerText={r(res.disclaimer['landsbankinn'])}
            einkabrefDisclaimer={r(fundRes.einkabrefDisclaimer['landsbankinn'])}
            foreignCurrencyDisclaimer={r(
              fundRes.foreignCurrencyDisclaimer['landsbankinn'],
            )}
            fundsDisclaimer={r(fundRes.fundsDisclaimer3['landsbankinn'])}
          />
        </Reveal>
      )}
      {!isEmpty && (
        <Reveal>
          <Disclaimer>
            <PrismicText value={disclaimer} />
          </Disclaimer>
        </Reveal>
      )}
    </Segment>
  );
};
